import { SquareButton } from "./SquareButton";
export default function GroupmeButton() {
  return <SquareButton variant="contained" href="https://groupme.com/join_group/102526205/VG77ie5z" target="_blank">GroupMe</SquareButton>;
}
